// src/components/spinner/ContainerLoader.jsx
import React from "react";
import { MultiOrbitSpinner3 } from "../../lib/myIcons";

export default function ContainerLoader() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: "200px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "transparent",
      }}
    >
      <MultiOrbitSpinner3 />
    </div>
  );
}
